/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { DeleteSettingsServiceApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    deleteSettingsService: build.mutation<unknown, DeleteSettingsServiceApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/v1/settings/services/${queryArg.serviceId}`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as deleteSettingsServiceApi };
export const { useDeleteSettingsServiceMutation } = injectedRtkApi;
